function Hero() {
  return (
    <section id="top" className="relative overflow-hidden bg-background-50">
      <div className="mx-auto grid w-full max-w-7xl flex-col gap-8 px-4 pb-12 pt-28 md:px-6 md:pt-36 lg:grid-cols-[1.15fr_0.85fr] lg:items-center lg:gap-12 lg:pb-20">
        {/* Text column */}
        <div className="order-2 lg:order-1">
          <p className="mb-5 inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-3 py-1.5 font-label text-xs uppercase tracking-[0.2em] text-primary-700">
            <i className="ri-radio-line"></i>
            身份追踪 · 专项入口
          </p>

          <h1 className="font-heading text-3xl font-black leading-tight tracking-tight text-foreground-950 md:text-5xl md:leading-[1.15]">
            四一爆料，
            <span className="text-primary-600">到底是谁？</span>
          </h1>

          <p className="mt-5 max-w-xl font-heading text-lg font-medium leading-relaxed text-foreground-700 md:text-xl">
            一个持续发声却始终匿名的爆料账号。围绕“它背后站着谁”，网友已展开多轮追问——身份背景、真名照片、资历来路，说法纷杂，真假难辨。
          </p>

          <p className="mt-4 max-w-xl text-[15px] leading-relaxed text-foreground-600">
            本站把分散在评论区、粉丝群与讨论社区的现有信息做了一次整理汇总：什么人、哪些说法、可信到哪一步。不动摇、不定论，只做一份便于对照的索引，帮你快速判断这个爆料账号的来路与可信度。
          </p>

          {/* meta chips */}
          <div className="mt-7 flex flex-wrap items-center gap-x-6 gap-y-2 text-sm text-foreground-600">
            <span className="inline-flex items-center gap-1.5 whitespace-nowrap">
              <i className="ri-file-list-3-line text-primary-500"></i>线索 5 档已归档
            </span>
            <span className="inline-flex items-center gap-1.5 whitespace-nowrap">
              <i className="ri-time-line text-primary-500"></i>本页更新于 2026-09
            </span>
            <span className="inline-flex items-center gap-1.5 whitespace-nowrap">
              <i className="ri-refund-2-line text-primary-500"></i>0 条实锤 · 谨慎对照
            </span>
          </div>

          {/* actions */}
          <div className="mt-8 flex flex-col gap-3 sm:flex-row">
            <a
              href="#focus"
              className="whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-center text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
            >
              先看四大身份追问
            </a>
            <a
              href="#credibility"
              className="whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-3 text-center text-sm font-semibold text-foreground-900 transition-colors hover:border-primary-300 hover:text-primary-700"
            >
              直接看可信度评估
            </a>
          </div>
        </div>

        {/* Image column */}
        <div className="order-1 lg:order-2">
          <div className="relative overflow-hidden rounded-lg">
            <img
              src="https://readdy.ai/api/search-image?query=editorial%20abstract%20concept%20of%20tracing%20an%20anonymous%20identity%2C%20stacked%20vintage%20paper%20documents%20and%20newsprint%20fragments%20layered%20on%20a%20warm%20desk%2C%20a%20large%20subtle%20soft-focus%20ink%20silhouette%20hanging%20above%2C%20warm%20cream%20and%20terracotta%20and%20burnt%20umber%20palette%2C%20soft%20directional%20window%20light%2C%20minimal%20magazine%20editorial%20composition%2C%20no%20people%2C%20no%20legible%20text%2C%20film%20grain&width=760&height=940&seq=hero-identity-01&orientation=portrait"
              alt="四一爆料身份追踪"
              className="h-[300px] w-full object-cover sm:h-[420px] lg:h-[560px]"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent"></div>
            <span className="absolute bottom-4 left-4 rounded-md bg-background-50/95 px-3 py-1.5 text-xs font-medium text-foreground-800">
              配图仅示意，非真实本人照片
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;